import type { ColDef } from "ag-grid-community";
import { generateColumn, renderNA } from "../../../../../utils/commonFunctions";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";

const vrTrainingLocationColumn: ColDef = {
  ...generateColumn("VR Training Location"),
  headerName: "Locations",
};

const typeColumn: ColDef = {
  ...generateColumn("Type"),
};
const nameColumn: ColDef = {
  ...generateColumn("Name"),
};

const descriptionColumn: ColDef = {
  ...generateColumn("", "description"),
  tooltipValueGetter: (props: any) => {
    return renderNA(props?.data?.["description"]);
  },
  filterValueGetter: (props: any) => {
    return renderNA(props?.data?.["description"]);
  },
  valueGetter: (props: any) => {
    return props?.data?.["description"];
  },
};

const columnDefs: ColDef[] = [
  idColumn,
  nameColumn,
  vrTrainingLocationColumn,
  typeColumn,
  descriptionColumn,
  statusColumn,
  actionColumn,
];
export default columnDefs;
